/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Constants from "app_constants";
import Theme from "./theme";

const options = [
  { value: "small", label: "1-10" },
  { value: "medium", label: "10-100" },
  { value: "large", label: "100-500" },
  { value: "xLarge", label: "500-1000" },
  { value: "xxLarge", label: "1000+" },
];

const RegisterView = (props) => {
  const { selectType, type, setFormData, register, error, logo } = props;

  return (
    <Theme type={type}>
      {Constants.metaTag}

      <div class="box">
        <div className="panel">
          <div className="field selectType">
            <label className="label">
              Are you seeking a job or do you want to publish a job ad in our
              platform?
            </label>
            <div class="actions columns is-desktop">
              <div class="column">
                <a
                  className="button is-success action"
                  onClick={() => selectType("user")}
                >
                  <span className="icon is-small">
                    <i className="fas fa-search"></i>
                  </span>
                  <span className="is-hidden-mobile">I am seeking a job</span>
                  <span className="is-hidden-tablet">Seek a job</span>
                </a>
              </div>
              <div class="column">
                <a
                  className="button is-info action publishJobAd"
                  onClick={() => selectType("company")}
                >
                  <span className="icon is-small">
                    <i className="fas fa-plus"></i>
                  </span>
                  <span className="is-hidden-mobile">
                    I will publish a job ad
                  </span>
                  <span className="is-hidden-tablet">Publish a job ad</span>
                </a>
              </div>
            </div>
          </div>

          {type && (
            <>
              <div className="field">
                <label className="label">E-mail</label>
                <div className="control">
                  <input
                    className="input is-info"
                    type="email"
                    onChange={(e) => {
                      setFormData("email", e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="field">
                <label className="label">Password</label>
                <div className="control">
                  <input
                    className="input is-info"
                    type="password"
                    onChange={(e) => {
                      setFormData("password", e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="field">
                <label className="label">
                  {type === "user" ? "Name" : "Company Name"}
                </label>
                <div className="control">
                  <input
                    className="input is-info"
                    type="text"
                    onChange={(e) => {
                      setFormData("name", e.target.value);
                    }}
                  />
                </div>
              </div>

              {type === "company" && (
                <>
                  <div className="field">
                    <label className="label">Company Location</label>
                    <div className="control">
                      <input
                        className="input is-info"
                        type="text"
                        onChange={(e) => {
                          setFormData("location", e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label">Company Web Site</label>
                    <div className="control">
                      <input
                        className="input is-info"
                        type="text"
                        onChange={(e) => {
                          setFormData("website", e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label">Company Size</label>
                    <Select
                      options={options}
                      onChange={(e) => {
                        setFormData("companySize", e.value);
                      }}
                    />
                  </div>

                  <div className="file has-name">
                    <label className="file-label">
                      <input
                        onChange={(e) => {
                          setFormData("logo", e.target.files[0]);
                        }}
                        className="file-input"
                        type="file"
                        name="resume"
                      />
                      <span className="file-cta">
                        <span className="file-icon">
                          <i className="fas fa-upload"></i>
                        </span>
                        <span className="file-label">Select Logo…</span>
                      </span>
                      {logo && <span className="file-name">{logo}</span>}
                    </label>
                  </div>
                </>
              )}
              {error && <p className="error">{error}</p>}
              <button
                onClick={register}
                className="button is-info is-fullwidth submit"
              >
                Sign Up
              </button>

              <div className="bottomSection">
                <Link to="/login">
                  <p className="link">Login</p>
                </Link>

                <Link to="/reset-password">
                  <p className="link">Reset Password</p>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </Theme>
  );
};

export default RegisterView;
